import { MakeCall } from './createMakeCall';

interface RegisterClickData {
  signature: string;
}

const registerListingCall =
  (makeCall: MakeCall) => (listingId: number, data: RegisterClickData) =>
    makeCall<undefined>('POST', `/api/v2/listing/${listingId}/register-click`, {
      data,
    });

export { registerListingCall };
